export default function Footer() {
  const exploreLinks = [
    { label: "關於我們", href: "/about" },
    { label: "服務條款", href: "/terms" },
    { label: "隱私政策", href: "/privacy" },
    { label: "聯絡我們", href: "mailto:contact@goldentimeguide.com" },
    { label: "加入成為神秘客", href: "/join-us" },
  ];

  const partnerLinks = [
    { label: "商家合作", href: "/partners" },
    { label: "部落格", href: "/articles" },
    { label: "作者專區", href: "/authors" },
    { label: "標籤總覽", href: "/tags" },
  ];

  const resourceLinks = [
    { label: "常見問題", href: "/faq" },
    { label: "城市指南", href: "/locations" },
    { label: "主題探索", href: "/topics" },
    { label: "探店精選", href: "/stores" },
  ];

  return (
    <footer className="bg-slate-50 border-t border-slate-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg overflow-hidden shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20bold%20geometric%20compass%20needle%20logo%20icon%20for%20a%20beauty%20discovery%20guide%20brand%2C%20featuring%20a%20sharp%20symmetrical%20directional%20pointer%20pointing%20northeast%20inside%20a%20perfect%20circular%20ring%2C%20with%20a%20small%20decorative%20star%20or%20diamond%20shape%20at%20the%20center%20pivot%20point%2C%20rendered%20in%20a%20striking%20two-tone%20palette%20of%20vivid%20burnt%20orange%20and%20warm%20ivory%20white%2C%20ultra-clean%20flat%20vector%20graphic%20with%20thick%20confident%20lines%2C%20absolutely%20no%20clock%20elements%2C%20no%20text%2C%20centered%20on%20a%20solid%20pure%20white%20background%2C%20modern%20app%20icon%20style%2C%20crisp%20edges%20and%20minimalist%20design%20suitable%20for%20website%20navigation%20bar%20branding&width=512&height=512&seq=gtg-compass-v3&orientation=squarish"
                  alt="美好時光指南 Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-bold text-lg text-slate-800">
                美好時光指南
              </span>
            </a>
            <p className="text-sm text-slate-500 leading-relaxed mb-4">
              台灣美業探店評比媒體，神秘客帶你找到最值得信賴的美業店家。
            </p>
            <div className="flex items-center gap-3">
              <span
                className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-400 cursor-default"
                title="Facebook 即將上線"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-facebook-fill" />
                </div>
              </span>
              <span
                className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-400 cursor-default"
                title="Instagram 即將上線"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-instagram-line" />
                </div>
              </span>
              <span
                className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-400 cursor-default"
                title="LINE 即將上線"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-line-fill" />
                </div>
              </span>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-sm font-semibold text-slate-800 mb-4">
              探索
            </h4>
            <ul className="space-y-2.5">
              {exploreLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-slate-500 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-semibold text-slate-800 mb-4">
              合作夥伴
            </h4>
            <ul className="space-y-2.5">
              {partnerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-slate-500 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources (replaces Members) */}
          <div>
            <h4 className="text-sm font-semibold text-slate-800 mb-4">
              站內資源
            </h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-slate-500 hover:text-primary transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-slate-400">
              &copy; 2025 美好時光指南 GoldenTimeGuides. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="/terms"
                className="text-xs text-slate-400 hover:text-slate-600 transition-colors"
              >
                服務條款
              </a>
              <a
                href="/privacy"
                className="text-xs text-slate-400 hover:text-slate-600 transition-colors"
              >
                隱私政策
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}